import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'subType';

export class SubType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
